import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import { isWebsocket1w1xog9vfgwm1 as isWebsocket } from '../../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { WebSocketContentagsn4p79ffe0 as WebSocketContent } from './WebSocketContent.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_request3dwcif5y0fvf1 as get_request } from '../../statement/HttpResponse.mjs';
import {
  toString1pkumu07cwy4m as toString,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance3047yo46wk0eo as Companion_getInstance } from '../../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import {
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  getKClass3t8tygqu4lcxf as getKClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { WebSocketSessionzi1ianvyj32u as WebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  DelegatingClientWebSocketSessiono1sywc6weckz as DelegatingClientWebSocketSession,
  DefaultClientWebSocketSession1n8ok3lng45wy as DefaultClientWebSocketSession,
} from './ClientSessions.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
  Phases_getInstance3j81i0dosd478 as Phases_getInstance,
} from '../../statement/HttpResponsePipeline.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { parseWebSocketExtensionszyo25w86ylog as parseWebSocketExtensions } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketExtensionHeader.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { header3kx6g3yb4df1r as header } from '../../request/utils.mjs';
import {
  WebSocketExtensionsConfig3sf1f7u7xi63m as WebSocketExtensionsConfig,
  WebSocketExtensionixqq2y77p4e0 as WebSocketExtension,
} from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketExtension.mjs';
import {
  WebSocketChannelsConfig1qogztyrywmj9 as WebSocketChannelsConfig,
  Companion_getInstance1onda8f6dyvl as Companion_getInstance_0,
} from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketChannelsConfig.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  getStarKTypeProjection316vzroubdy0t as getStarKTypeProjection,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { Phases_getInstance153dg9ipormlv as Phases_getInstance_0 } from '../../request/HttpRequestPipeline.mjs';
import {
  DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession,
  DefaultWebSocketSessionmehckluw85jl as DefaultWebSocketSession_0,
} from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  multiply2k9eolhnz1bjv as multiply,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { HttpClientEngineCapability33x11oaa7ywe5 as HttpClientEngineCapability } from '../../engine/HttpClientEngineCapability.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_REQUEST_EXTENSIONS_KEY() {
  _init_properties_WebSockets_kt__jaqpbo();
  return REQUEST_EXTENSIONS_KEY;
}
var REQUEST_EXTENSIONS_KEY;
function get_WEBSOCKETS_KEY() {
  _init_properties_WebSockets_kt__jaqpbo();
  return WEBSOCKETS_KEY;
}
var WEBSOCKETS_KEY;
function get_LOGGER() {
  _init_properties_WebSockets_kt__jaqpbo();
  return LOGGER;
}
var LOGGER;
function *_generator_invoke__zhh2q8($this, $this$intercept, it, $completion) {
  if (!isWebsocket($this$intercept.o4r_1.t5g_1.d54())) {
    // Inline function 'io.ktor.util.logging.trace' call
    var this_0 = get_LOGGER();
    if (get_isTraceEnabled(this_0)) {
      var tmp$ret$0 = 'Skipping WebSocket plugin for non-websocket request: ' + $this$intercept.o4r_1.t5g_1.toString();
      this_0.s4s(tmp$ret$0);
    }
    return Unit_instance;
  }
  // Inline function 'io.ktor.util.logging.trace' call
  var this_1 = get_LOGGER();
  if (get_isTraceEnabled(this_1)) {
    var tmp$ret$2 = 'Sending WebSocket request ' + $this$intercept.o4r_1.t5g_1.toString();
    this_1.s4s(tmp$ret$2);
  }
  $this$intercept.o4r_1.k5u(WebSocketCapability_instance, Unit_instance);
  if ($this.y5v_1) {
    installExtensions($this.z5v_1, $this$intercept.o4r_1);
  }
  $this$intercept.o4r_1.y5g_1.a4n(get_WEBSOCKETS_KEY(), $this.z5v_1);
  var tmp = $this$intercept.q4q(new (WebSocketContent())(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$intercept, _destruct__k2r9zo, $completion) {
  var info = _destruct__k2r9zo.df();
  var session = _destruct__k2r9zo.ef();
  var response = $this$intercept.o4r_1.q5g();
  var status = response.c5j();
  var requestContent = get_request(response).t2o();
  if (!(requestContent instanceof WebSocketContent())) {
    // Inline function 'io.ktor.util.logging.trace' call
    var this_0 = get_LOGGER();
    if (get_isTraceEnabled(this_0)) {
      var tmp$ret$0 = 'Skipping non-websocket response from ' + $this$intercept.o4r_1.m5i().v5i().toString() + ': ' + toString(requestContent);
      this_0.s4s(tmp$ret$0);
    }
    return Unit_instance;
  }
  if (!status.equals(Companion_getInstance().j51_1)) {
    throw WebSocketException().e5w('Handshake exception, expected status code ' + Companion_getInstance().j51_1.l53_1 + ' but was ' + status.l53_1);
  }
  if (!isInterface(session, WebSocketSession())) {
    throw WebSocketException().e5w('Handshake exception, expected `WebSocketSession` content but was ' + toString(getKClassFromExpression(session)));
  }
  // Inline function 'io.ktor.util.logging.trace' call
  var this_1 = get_LOGGER();
  if (get_isTraceEnabled(this_1)) {
    var tmp$ret$2 = 'Receive websocket session from ' + $this$intercept.o4r_1.m5i().v5i().toString() + ': ' + toString(session);
    this_1.s4s(tmp$ret$2);
  }
  if (!($this.k5w_1.g5w_1 === 2147483647n)) {
    session.d5a($this.k5w_1.g5w_1);
  }
  var tmp;
  if (info.g4s_1.equals(getKClass(DefaultClientWebSocketSession()))) {
    var defaultSession = $this.k5w_1.m5w(session);
    var clientSession = new (DefaultClientWebSocketSession())($this$intercept.o4r_1, defaultSession);
    var tmp_0;
    if ($this.l5w_1) {
      tmp_0 = completeNegotiation($this.k5w_1, $this$intercept.o4r_1);
    } else {
      tmp_0 = emptyList();
    }
    var negotiated = tmp_0;
    // Inline function 'kotlin.apply' call
    clientSession.c5a(negotiated);
    tmp = clientSession;
  } else {
    tmp = new (DelegatingClientWebSocketSession())($this$intercept.o4r_1, session);
  }
  var clientSession_0 = tmp;
  var tmp_1 = $this$intercept.q4q(new (HttpResponseContainer())(info, clientSession_0), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var WebSockets$Plugin$install$slambdaClass;
function WebSockets$Plugin$install$slambda() {
  if (WebSockets$Plugin$install$slambdaClass === VOID) {
    class $ {
      constructor($extensionsSupported, $plugin) {
        this.y5v_1 = $extensionsSupported;
        this.z5v_1 = $plugin;
      }
      z5g($this$intercept, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$intercept, it), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.z5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    WebSockets$Plugin$install$slambdaClass = $;
  }
  return WebSockets$Plugin$install$slambdaClass;
}
function WebSockets$Plugin$install$slambda_0($extensionsSupported, $plugin) {
  var i = new (WebSockets$Plugin$install$slambda())($extensionsSupported, $plugin);
  var l = ($this$intercept, it, $completion) => i.z5g($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var WebSockets$Plugin$install$slambdaClass_0;
function WebSockets$Plugin$install$slambda_1() {
  if (WebSockets$Plugin$install$slambdaClass_0 === VOID) {
    class $ {
      constructor($plugin, $extensionsSupported) {
        this.k5w_1 = $plugin;
        this.l5w_1 = $extensionsSupported;
      }
      a5h($this$intercept, _destruct__k2r9zo, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$intercept, _destruct__k2r9zo), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.a5h(tmp, p2 instanceof HttpResponseContainer() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    WebSockets$Plugin$install$slambdaClass_0 = $;
  }
  return WebSockets$Plugin$install$slambdaClass_0;
}
function WebSockets$Plugin$install$slambda_2($plugin, $extensionsSupported) {
  var i = new (WebSockets$Plugin$install$slambda_1())($plugin, $extensionsSupported);
  var l = ($this$intercept, _destruct__k2r9zo, $completion) => i.a5h($this$intercept, _destruct__k2r9zo, $completion);
  l.$arity = 2;
  return l;
}
function installExtensions($this, context) {
  var installed = $this.h5w_1.n37();
  context.y5g_1.z4m(get_REQUEST_EXTENSIONS_KEY(), installed);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList().u2();
  var _iterator__ex2g4s = installed.u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    var list = element.z5d();
    addAll(destination, list);
  }
  var protocols = destination;
  addNegotiatedProtocols($this, context, protocols);
}
function completeNegotiation($this, call) {
  var tmp0_safe_receiver = call.q5g().n50().w2o('Sec-WebSocket-Extensions');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = parseWebSocketExtensions(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  var serverExtensions = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  var clientExtensions = call.n5i().w4m(get_REQUEST_EXTENSIONS_KEY());
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().u2();
  var _iterator__ex2g4s = clientExtensions.u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    if (element.a5e(serverExtensions)) {
      destination.n2(element);
    }
  }
  return destination;
}
function addNegotiatedProtocols($this, context, protocols) {
  if (protocols.s1())
    return Unit_instance;
  var headerValue = joinToString(protocols, ',');
  header(context, 'Sec-WebSocket-Extensions', headerValue);
}
var ConfigClass;
function Config() {
  if (ConfigClass === VOID) {
    class $ {
      constructor() {
        this.n5w_1 = new (WebSocketExtensionsConfig())();
        this.o5w_1 = new (WebSocketChannelsConfig())();
        this.p5w_1 = 0n;
        this.q5w_1 = 2147483647n;
        this.r5w_1 = null;
      }
    }
    initMetadataForClass($, 'Config', Config);
    ConfigClass = $;
  }
  return ConfigClass;
}
var PluginClass;
function Plugin() {
  if (PluginClass === VOID) {
    class $ {
      constructor() {
        Plugin_instance = this;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'Websocket';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(WebSockets());
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_1;
        try {
          tmp_1 = createKType(getKClass(WebSockets()), arrayOf([]), false);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_1 = tmp_2;
        }
        var tmp$ret$0 = tmp_1;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$0);
        tmp.s5w_1 = new (AttributeKey())(name, tmp$ret$1);
      }
      r3() {
        return this.s5w_1;
      }
      t5w(block) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (Config())();
        block(this_0);
        var config = this_0;
        return new (WebSockets())(config.p5w_1, config.q5w_1, config.n5w_1, config.r5w_1, config.o5w_1);
      }
      c5i(block) {
        return this.t5w(block);
      }
      u5w(plugin, scope) {
        var extensionsSupported = scope.w5f_1.r5l().y2(WebSocketExtensionsCapability_instance);
        var tmp = Phases_getInstance_0().q5m_1;
        scope.c5g_1.s4r(tmp, WebSockets$Plugin$install$slambda_0(extensionsSupported, plugin));
        var tmp_0 = Phases_getInstance().w5h_1;
        scope.d5g_1.s4r(tmp_0, WebSockets$Plugin$install$slambda_2(plugin, extensionsSupported));
      }
      d5i(plugin, scope) {
        return this.u5w(plugin instanceof WebSockets() ? plugin : THROW_CCE(), scope);
      }
    }
    initMetadataForObject($, 'Plugin');
    PluginClass = $;
  }
  return PluginClass;
}
var Plugin_instance;
function Plugin_getInstance() {
  if (Plugin_instance === VOID)
    new (Plugin())();
  return Plugin_instance;
}
var WebSocketsClass;
function WebSockets() {
  if (WebSocketsClass === VOID) {
    class $ {
      constructor(pingIntervalMillis, maxFrameSize, extensionsConfig, contentConverter, channelsConfig) {
        Plugin_getInstance();
        contentConverter = contentConverter === VOID ? null : contentConverter;
        channelsConfig = channelsConfig === VOID ? Companion_getInstance_0().i5a_1 : channelsConfig;
        this.f5w_1 = pingIntervalMillis;
        this.g5w_1 = maxFrameSize;
        this.h5w_1 = extensionsConfig;
        this.i5w_1 = contentConverter;
        this.j5w_1 = channelsConfig;
      }
      m5w(session) {
        if (isInterface(session, DefaultWebSocketSession()))
          return session;
        // Inline function 'kotlin.Long.times' call
        var this_0 = this.f5w_1;
        var timeoutMillis = multiply(this_0, fromInt(2));
        // Inline function 'kotlin.also' call
        var this_1 = DefaultWebSocketSession_0(session, this.f5w_1, timeoutMillis, this.j5w_1);
        this_1.d5a(this.g5w_1);
        return this_1;
      }
    }
    initMetadataForClass($, 'WebSockets');
    WebSocketsClass = $;
  }
  return WebSocketsClass;
}
var WebSocketExtensionsCapabilityClass;
function WebSocketExtensionsCapability() {
  if (WebSocketExtensionsCapabilityClass === VOID) {
    class $ {
      toString() {
        return 'WebSocketExtensionsCapability';
      }
      hashCode() {
        return 806573237;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WebSocketExtensionsCapability()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'WebSocketExtensionsCapability', VOID, VOID, [HttpClientEngineCapability()]);
    WebSocketExtensionsCapabilityClass = $;
  }
  return WebSocketExtensionsCapabilityClass;
}
var WebSocketExtensionsCapability_instance;
function WebSocketExtensionsCapability_getInstance() {
  return WebSocketExtensionsCapability_instance;
}
var WebSocketCapabilityClass;
function WebSocketCapability() {
  if (WebSocketCapabilityClass === VOID) {
    class $ {
      toString() {
        return 'WebSocketCapability';
      }
      hashCode() {
        return -1146563391;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WebSocketCapability()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'WebSocketCapability', VOID, VOID, [HttpClientEngineCapability()]);
    WebSocketCapabilityClass = $;
  }
  return WebSocketCapabilityClass;
}
var WebSocketCapability_instance;
function WebSocketCapability_getInstance() {
  return WebSocketCapability_instance;
}
var WebSocketExceptionClass;
function WebSocketException() {
  if (WebSocketExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static v5w(message, cause) {
        var $this = this.q(message, cause);
        captureStack($this, $this.d5w_1);
        return $this;
      }
      static e5w(message) {
        return this.v5w(message, null);
      }
    }
    initMetadataForClass($, 'WebSocketException');
    WebSocketExceptionClass = $;
  }
  return WebSocketExceptionClass;
}
var properties_initialized_WebSockets_kt_2t2hw2;
function _init_properties_WebSockets_kt__jaqpbo() {
  if (!properties_initialized_WebSockets_kt_2t2hw2) {
    properties_initialized_WebSockets_kt_2t2hw2 = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'Websocket extensions';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(KtList());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(KtList()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(WebSocketExtension()), arrayOf([getStarKTypeProjection()]), false))]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$0 = tmp_0;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp$ret$0);
    REQUEST_EXTENSIONS_KEY = new (AttributeKey())(name, tmp$ret$1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_0 = 'Websocket plugin config';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_2 = getKClass(WebSockets());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_3;
    try {
      tmp_3 = createKType(getKClass(WebSockets()), arrayOf([]), false);
    } catch ($p) {
      var tmp_4;
      if ($p instanceof Error) {
        var _unused_var__etf5q3_0 = $p;
        tmp_4 = null;
      } else {
        throw $p;
      }
      tmp_3 = tmp_4;
    }
    var tmp$ret$0_0 = tmp_3;
    var tmp$ret$1_0 = new (TypeInfo())(tmp_2, tmp$ret$0_0);
    WEBSOCKETS_KEY = new (AttributeKey())(name_0, tmp$ret$1_0);
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.websocket.WebSockets');
  }
}
//region block: init
WebSocketExtensionsCapability_instance = new (WebSocketExtensionsCapability())();
WebSocketCapability_instance = new (WebSocketCapability())();
//endregion
//region block: exports
export {
  WebSocketCapability_instance as WebSocketCapability_instance1mjnqrz16anqe,
  Plugin_getInstance as Plugin_getInstancefllmgjpjiqqy,
  get_WEBSOCKETS_KEY as get_WEBSOCKETS_KEY4y3dps3lzl71,
  WebSocketException as WebSocketExceptionb5mwyitzck0i,
};
//endregion

//# sourceMappingURL=WebSockets.mjs.map
